import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import type {
  InitialStateType,
  SetLocationHubOptionsPayloadActionType,
  SetBlacklistDetailsPayloadActionType,
  SetBlacklistFormPayloadActionType,
  SetLocationDetailPayloadActionType,
} from 'features/Location/@types/BlacklistAreaAddEdit'

export const SLICE_NAME = 'blacklistAreaAddEdit'

export const initialState: InitialStateType = {
  isLoading: [],
  locationHubOptions: [],
  blacklistDetails: [],
  blacklistForm: {
    address: '',
    duration_type: '',
    end_date: '',
    end_day: '',
    end_time: '',
    start_date: '',
    start_day: '',
    start_time: '',
    type: 0,
    id: '',
    is_active: true,
    location: { id: 0, name: '', type: 'HUB' },
    file: '',
    fileName: '',
    updated_by: '',
  },
  locationDetail: { location_address: '', location_id: 0, location_name: '', location_type: '' },
}

const slice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    reset: () => initialState,
    resetLocationDetail: (state) => {
      state.locationDetail = initialState.locationDetail
    },
    resetBlacklistForm: (state) => {
      state.blacklistForm = initialState.blacklistForm
    },
    resetBlacklistFormExceptLocation: (state) => {
      state.blacklistForm = {
        ...initialState.blacklistForm,
        location: state.blacklistForm.location,
      }
    },
    setIsLoading: (state, { payload }: PayloadAction<boolean>) => {
      if (payload) {
        state.isLoading.push(true)
      } else {
        state.isLoading.pop()
      }
    },
    setLocationHubOptions: (
      state,
      { payload }: PayloadAction<SetLocationHubOptionsPayloadActionType>,
    ) => {
      state.locationHubOptions = payload
    },
    setBlacklistDetails: (
      state,
      { payload }: PayloadAction<SetBlacklistDetailsPayloadActionType>,
    ) => {
      state.blacklistDetails = payload
    },
    addBlacklistDetail: (state) => {
      state.blacklistDetails.push(state.blacklistForm)
    },
    editBlacklistDetail: (state) => {
      const findIndex = state.blacklistDetails.findIndex((el) => el.id === state.blacklistForm.id)

      state.blacklistDetails[findIndex] = { ...state.blacklistForm }
    },
    removeBlacklistDetail: (state, { payload }: PayloadAction<number>) => {
      state.blacklistDetails.splice(payload, 1)
    },
    setBlacklistForm: (state, { payload }: PayloadAction<SetBlacklistFormPayloadActionType>) => {
      state.blacklistForm = { ...state.blacklistForm, ...payload }
    },
    setLocationDetail: (state, { payload }: PayloadAction<SetLocationDetailPayloadActionType>) => {
      state.locationDetail = { ...state.locationDetail, ...payload }
    },
  },
})

export const {
  reset,
  setIsLoading,
  setLocationHubOptions,
  setBlacklistDetails,
  setBlacklistForm,
  addBlacklistDetail,
  removeBlacklistDetail,
  setLocationDetail,
  resetBlacklistForm,
  resetBlacklistFormExceptLocation,
  editBlacklistDetail,
} = slice.actions
export default slice.reducer
